module.exports = __webpack_public_path__ + "img/bg1.48d378c4.png";